import { useState } from "react";
import { Card, CardBody, Col, Label, Row, FormGroup, Input, Button } from "reactstrap";
import { ImageDropZonePreview } from "../../globals/core/ImageDropZonePreview/ImageDropZonePreview";
import Select from "react-select";

export const CommunityForm = (props) => {

    const { currentCommunity, action } = props;
    const initialState = {
        name: currentCommunity ? currentCommunity.name : '',
        description: currentCommunity ? currentCommunity.description : '',
        selectedFiles: [],
        image: currentCommunity ? currentCommunity.image : '',
        communityType: currentCommunity ? currentCommunity.communityType : 'standard'
    }
    const [state, setState] = useState(initialState)

    const options = [
        { value: 'standard', label: "Standard" },
        { value: 'system', label: "System" }
    ]

    const handleForm = (props) => {
        setState({
            ...state,
            ...props
        })
    }

    const handleDropZone = ({ selectedFiles }) => {
        const lastFile = selectedFiles.pop();
        setState({ ...state, selectedFiles: [lastFile], image: lastFile });
    };

    const handleAction = () => {
        const c = {}
        if (currentCommunity) {
            Object.assign(c, { _id: currentCommunity._id })
        }
        Object.assign(c, {
            image: state.image,
            name: state.name,
            description: state.description,
            communityType: state.communityType
        });
        action(c)
    }

    const renderForm = () => {
        return (
            <Card>
                <CardBody>
                    <div className="row">
                        <div className="col-md-6 col-12 px-2">
                            <h4>Community Details</h4>
                            <Row className="mt-3">
                                <Col sm={12} className="px-2">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_name">Name</Label></h5>
                                        <Input
                                            value={state.name}
                                            onChange={(e) => handleForm({ name: e.target.value })}
                                            type="text"
                                            id="_name">
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm={12} className="px-2">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_desc">Description</Label></h5>
                                        <textarea
                                            className="form-control"
                                            value={state.description}
                                            onChange={(e) => handleForm({ description: e.target.value })}
                                            id="_desc">
                                        </textarea>
                                    </FormGroup>
                                </Col>
                                <Col sm={12} className="px-2">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_image">Image</Label></h5>
                                        <ImageDropZonePreview
                                            onChange={handleDropZone}
                                            selectedFiles={state.selectedFiles}
                                            accept="image/png, image/gif, image/jpeg"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={12} className="px-2">
                                    <FormGroup>
                                        <Label htmlFor="title">Community Type</Label>
                                        <div className="mb-3 select2-container">
                                            <Select
                                                value={options.find(o => o.value === state.communityType)}
                                                onChange={(s) => {
                                                    handleForm({ communityType: s.value });
                                                }}
                                                options={options}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                    </div>

                </CardBody>
            </Card>
        )
    }

    return (
        <div className="container">
            <div className="row my-3">
                <h3>{currentCommunity ? 'Edit Community' : 'Add Community'}</h3>
            </div>
            <div className="row my-2">
                {renderForm()}
            </div>
            <div className="row">
                <div className="d-flex justify-content-end">
                    <Button onClick={handleAction} color={"success"}>{currentCommunity ? 'Save Changes' : 'Add Community'}</Button>
                    {currentCommunity ? <Button className="mx-3" color={"danger"}>Delete</Button> : null}
                </div>
            </div>
        </div>
    )
}